import types from './types';

export default {
  careerListRequested: () => ({
    type: types.CAREER_LIST_REQUESTED,
  }),
  careerListSucceeded: (data) => ({
    type: types.CAREER_LIST_SUCCEEDED,
    data,
  }),
  careerListFailed: (error) => ({
    type: types.CAREER_LIST_FAILED,
    error,
  }),
};
